import { forwardRef, type Ref, type SVGProps } from "react";
const IconAppDownloadFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M9.476 2h13.048a1.87 1.87 0 0 1 1.864 1.867v24.266A1.87 1.87 0 0 1 22.524 30H9.476a1.87 1.87 0 0 1-1.864-1.867V3.867A1.87 1.87 0 0 1 9.476 2m3.98 3.03a.933.933 0 1 1-1.865 0 .933.933 0 0 1 1.866 0m3.729.933H15.32a.933.933 0 0 1 0-1.867h1.864a.933.933 0 0 1 0 1.867m-.932 21.36a.933.933 0 1 0-.002-1.865.933.933 0 0 0 .002 1.865m-.303-5.534a1.6 1.6 0 0 1-1.155-.495l-2.817-3.034a1.07 1.07 0 0 1 .101-1.452 1.064 1.064 0 0 1 1.454.002l1.352 1.45v-6.044a1.066 1.066 0 1 1 2.13 0v6.044l1.352-1.45a1.064 1.064 0 0 1 1.852.382c.108.384-.006.796-.297 1.068l-2.817 3.034a1.6 1.6 0 0 1-1.155.495"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconAppDownloadFilledSVG);
ForwardRef.displayName = "IconAppDownloadFilled";
export { ForwardRef as IconAppDownloadFilled };
